import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Layout from '/src/ui/core/layouts/layout'
import ThreeDotsLoader from '/src/ui/core/loaders/three_dots_loader'
import useModelController from '/src/hooks/model_controller'
import InspectionForm from '/src/ui/domain/inspections/inspection_form'
import { useQueryParam, NumberParam } from 'use-query-params'
import { buildBackURL } from '/src/utils/url'

export default function InspectionFormPage({ match }) {
  const history = useHistory()
  const [requestId] = useQueryParam('request_id', NumberParam)
  const [templateId] = useQueryParam('eav_template_id', NumberParam)

  const backURLConfig = () => ({
    eavTemplateId: templateId,
    requestId
  })

  const { dataItem, loading } = useModelController({
    modelType: 'inspections',
    dataItemId: match.params.id,
    onBack: () => history.push(`/inspections?${buildBackURL(backURLConfig())}`),
    onFinish: () => history.push(`/inspections?${buildBackURL(backURLConfig())}`),
  })

  return (
    <Layout key={dataItem} showProjectSwitcher={false}>
      {loading ? (
        <ThreeDotsLoader />
       ) : (
         <InspectionForm
           dataItem={dataItem || undefined}
           templateId={templateId}
           type={match.params.collection}
         />
       )}
    </Layout>
  )
}

InspectionFormPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      collection: PropTypes.string
    })
  })
}

InspectionFormPage.defaultProps = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: undefined,
      collection: undefined
    })
  })
}
